import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class MapContainer extends Component {

  static propTypes = {
    children: PropTypes.node
  }

  render() {
    return (
      <div className="container-fluid vertical content map-container">
        {this.props.children}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/map/containers/Container.js